import { Link, Head } from "@inertiajs/react";
import { useForm } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";

import usePage from "@/hooks/usePage";
import { TextField } from "@/components/TextField/TextField";
import { SessionFormsLayout } from "@/layouts/SessionForms";

type Inputs = {
  "user[email]": string;
};

export default function NewSession() {
  const { props } = usePage();
  const { register } = useForm<Inputs>();

  if (props.flash?.notice) {
    toast.success(props.flash.notice, {
      duration: 5000,
    });
  }

  return (
    <>
      <Head>
        <title>Sign In</title>
        <meta name="description" content="Sign In to Blpnt" />
      </Head>
      <Toaster closeButton />
      <form
        className="w-full flex flex-col gap-2"
        action="/users/sign_in"
        method="POST"
      >
        <input
          type="hidden"
          name="authenticity_token"
          value={props.csrf_token}
        />
        <h1 className="text-center text-3xl font-medium relative after:content-[''] after:block after:w-px after:h-[42px] after:mt-4 after:mx-auto after:bg-gray-300">
          Sign In
        </h1>
        <TextField
          placeholder="email@example.com"
          label="Email"
          {...register("user[email]", { required: true })}
        />
        <Button type="submit">Sign In</Button>
      </form>
      <p className="mt-4 text-sm text-gray-500">
        Don't have an account?{" "}
        <Link href="/users/sign_up" className="text-primary">
          Create one.
        </Link>
      </p>
    </>
  );
}

NewSession.layout = (page: React.ReactNode) => (
  <SessionFormsLayout children={page} />
);
